<script>
import NavigationWrapper from "@/components/NavigationWrapper";

export default {
  // Included components
  components: {
    NavigationWrapper,
  },
};
</script>

<template>
  <NavigationWrapper>
    <template #breadcrumbs>
      <b-breadcrumb-item to="/help">Help</b-breadcrumb-item>
      <b-breadcrumb-item active>FAQ</b-breadcrumb-item>
    </template>
    <h1 class="mb-3">Frequently Asked Questions</h1>
    <b-card>
      <div class="item">
        <div class="question">
          <h5 id="add-a-miner">
            <b-link to="#add-a-miner">How do I add a miner to mine.app?</b-link>
            <span class="anchor-indicator">#</span>
          </h5>
        </div>
        <p class="answer">
          First,
          <b-link to="/workers/create">add a worker</b-link>
          to represent the miner. Select the device type (e.g.
          <b>Spondoolies SPx36</b>
          ), and decide on a name to represent it, e.g.
          <b>SPx36 001</b>
          as well as a unique handle, like
          <b>spx36-001</b>
          . Select the pool you want the miner to use, and enter the worker name
          for the pool (and password, if required).
        </p>
        <p class="answer">
          Once you've configured a worker, edit the pool configuration on you
          miner, setting the pool url to
          <b>core.mine.app:9999</b>
          and the worker username to your team handle and worker handle,
          separated by a dot, e.g.
          <b>navier.spx36-001</b>
          .
        </p>
      </div>
      <div class="item">
        <div class="question">
          <h5 id="inactive-worker-charge">
            <b-link to="#inactive-worker-charge">
              Do I get charged for inactive workers?
            </b-link>
            <span class="anchor-indicator">#</span>
          </h5>
        </div>
        <p class="answer">
          When on the
          <b>Pro</b>
          plan, you are not charged for inactive workers. Billing is usage-based
          at 5-minute resolution, so if your miners turn off for part of the
          day, you won't be charged for that time.
        </p>
      </div>
      <div class="item">
        <div class="question">
          <h5 id="two-factor-authentication">
            <b-link to="#two-factor-authentication">
              How do I enable two-factor authentication for my account?
            </b-link>
            <span class="anchor-indicator">#</span>
          </h5>
        </div>
        <p class="answer">
          To enable two-factor authentication, navigate the
          <b-link to="/account/security">Account / Security</b-link>
          and click the
          <b>Enable two-factor authentication</b>
          button. Scan the QR code using a soft token authenticator app like
          Google Authenticator. If you can't scan the QR code, use the
          manual-entry secret shown below the image.
        </p>
        <p class="answer">
          Then enter the code displayed in the authenticator app in the
          <b>Authentication code</b>
          input and press
          <b>Enable two-factor</b>
          . Whenever you log in, you will be prompted to enter another
          two-factor code.
        </p>
      </div>
      <div class="item">
        <div class="question">
          <h5 id="cancellation-billing">
            <b-link to="#cancellation-billing">
              What will I be charged when I cancel a Pro plan?
            </b-link>
            <span class="anchor-indicator">#</span>
          </h5>
        </div>
        <p class="answer">
          You have 72 hours from the start of your billing cycle to cancel your
          <b>Pro</b>
          plan before you are billed the regular monthly charge. After that,
          usage will be calculated only for the time used, but the $5 minimum
          will still apply.
        </p>
      </div>
      <div class="item">
        <div class="question">
          <h5 id="group-vs-team">
            <b-link to="#group-vs-team">
              What's the difference between a group and a team?
            </b-link>
            <span class="anchor-indicator">#</span>
          </h5>
        </div>
        <p class="answer">
          A
          <b>group</b>
          organizes workers for monitoring and analytics, typically representing
          a deployment, type of miner, or physical location. A worker can be a
          part of multiple groups, so you could have
          <b>A9s</b>
          ,
          <b>Deployment A</b>
          , and
          <b>USA Miners</b>
          , even if they overlap.
        </p>
        <p class="answer">
          A
          <b>team</b>
          organizes people, typically representing the company that owns the
          physical miners.
        </p>
      </div>
    </b-card>
  </NavigationWrapper>
</template>

<style scoped>
.item:not(:last-child) {
  margin-bottom: 2rem;
}

.item .question {
  font-weight: bold;
}

.item .question .anchor-indicator {
  opacity: 0;
  margin-left: 0.25rem;
  color: rgb(173, 173, 173);
}

.item .question a:hover ~ .anchor-indicator {
  opacity: 1;
}
</style>
